import { render, staticRenderFns } from "./Refusal.vue?vue&type=template&id=bdea8dc4&scoped=true"
import script from "./Refusal.vue?vue&type=script&lang=js"
export * from "./Refusal.vue?vue&type=script&lang=js"
import style0 from "./Refusal.vue?vue&type=style&index=0&id=bdea8dc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdea8dc4",
  null
  
)

export default component.exports